import { Theme } from "@emotion/react";
import { mdsCommonTheme } from "../common";

export const mdsThemeLight: Theme = {
  ...mdsCommonTheme,
  // add any light-specific theme overrides here
};
